import { Logo } from 'foundations-components/transitional/components/Logo';
import { SprocketIcon } from 'foundations-assets';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoBody = ({
  altText,
  showMobileView,
  imageSrc,
  width,
  height
}) => {
  if (imageSrc) {
    return /*#__PURE__*/_jsx(Image, {
      alt: altText,
      blockSize: `${height || 40}px`,
      responsive: false,
      src: imageSrc,
      inlineSize: `${width}px`
    });
  }
  if (showMobileView) {
    return /*#__PURE__*/_jsx(SprocketIcon, {
      color: "fill-accent-orange-default",
      size: "700"
    });
  }
  return /*#__PURE__*/_jsx(Logo, {
    alt: altText,
    name: "hubspot-wordmark",
    width: "128px"
  });
};